/* NEULO waiting-list routing. Only the two declared waiting-list form mounts are touched. */
(function () {
  'use strict';
  const roots = Array.from(document.querySelectorAll('[data-neulo-waitlist-router]'));
  if (!roots.length) return;
  const japanese = (document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ja';
  const labels = japanese ? {
    country: '居住国', choose: 'お住まいの国を選択してください',
    loading: 'フォームを読み込み中です。', error: 'フォームを読み込めませんでした。ページを再読み込みしてください。',
    mismatch: '居住国を選び直してから、もう一度登録してください。'
  } : {
    country: 'Country of residence', choose: 'Please select your country of residence',
    loading: 'Loading the form…', error: 'The form could not be loaded. Please reload this page.',
    mismatch: 'Please select your country of residence again before submitting.'
  };
  roots.forEach(function (root, index) {
    const loading = root.querySelector('.neulo-waitlist-loading');
    if (loading) loading.textContent = labels.loading;
    const panels = {global: root.querySelector('[data-waitlist-panel="global"]'), domestic: root.querySelector('[data-waitlist-panel="domestic"]')};
    let selector, current = null, submitting = false, succeeded = false;
    const countryField = panel => panel && panel.querySelector('select[name="select-2"]');
    const targetFor = country => japanese && country === 'Japan' ? 'domestic' : 'global';
    const notify = element => { element.dispatchEvent(new Event('input', {bubbles:true})); element.dispatchEvent(new Event('change', {bubbles:true})); };
    function copyInputs(from, to) {
      if (!from || !to || from === to) return;
      // Preserve user-entered fields only. Never copy form IDs, integration fields, hidden values or tokens.
      ['text-1','text','email','select-1','consent-1[]'].forEach(function(name) {
        const source = Array.from(from.querySelectorAll('input,select')).find(e => e.name === name);
        const dest = Array.from(to.querySelectorAll('input,select')).find(e => e.name === name);
        if (!source || !dest) return;
        if (source.type === 'checkbox') dest.checked = source.checked; else dest.value = source.value;
        notify(dest);
      });
    }
    function reflectCountry() {
      if (!selector) return;
      const residence = selector.value;
      Object.values(panels).forEach(function(panel) {
        const field = countryField(panel);
        if (field && field.value !== residence) { field.value = residence; notify(field); }
        if (residence !== 'Japan') {
          const prefecture = panel.querySelector('select[name="select-1"]');
          if (prefecture && prefecture.value) { prefecture.value = ''; notify(prefecture); }
        }
      });
    }
    function choose() {
      if (submitting) return;
      // Show a complete form before country selection; submission still requires an explicit country.
      const next = selector.value ? targetFor(selector.value) : (japanese ? 'domestic' : 'global');
      if (next && current !== next) copyInputs(panels[current], panels[next]);
      current = next;
      root.dataset.countryPending = String(!selector.value);
      reflectCountry();
      Object.entries(panels).forEach(function([key,panel]) {
        panel.dataset.active = String(key === current);
        panel.inert = key !== current;
        panel.setAttribute('aria-hidden', String(key !== current));
      });
      root.querySelector('.neulo-waitlist-error')?.remove();
    }
    function initialize() {
      if (selector) return;
      const original = countryField(panels.global);
      if (!original || !countryField(panels.domestic)) return;
      const field = document.createElement('div'); field.className = 'neulo-residence';
      const label = document.createElement('label'); label.htmlFor = 'neulo-residence-' + index; label.textContent = labels.country + ' *';
      selector = document.createElement('select'); selector.id = label.htmlFor; selector.required = true;
      const empty = document.createElement('option'); empty.value = ''; empty.textContent = labels.choose; empty.disabled = true; empty.selected = true; selector.appendChild(empty);
      Array.from(original.options).filter(o => o.value).forEach(function(option) { const copy = document.createElement('option'); copy.value = option.value; copy.textContent = option.textContent; selector.appendChild(copy); });
      field.append(label,selector); root.insertBefore(field,root.firstChild); if (loading) loading.remove();
      selector.value = ''; selector.addEventListener('change', choose); choose();
    }
    function error() {
      if (!root.querySelector('.neulo-waitlist-error')) {const p=document.createElement('p');p.className='neulo-waitlist-error';p.setAttribute('role','alert');p.textContent=labels.mismatch;root.prepend(p);}
      selector?.focus();
    }
    root.addEventListener('submit', function(event) {
      const panel = event.target.closest('[data-waitlist-panel]');
      if (!panel) return;
      const actualCountry = countryField(panel)?.value;
      const expectedId = panel.dataset.waitlistPanel === 'domestic' ? '163837' : '128186';
      if (submitting || !selector?.value || panel.dataset.waitlistPanel !== current || targetFor(selector.value) !== current || actualCountry !== selector.value || event.target.getAttribute('data-id') !== expectedId) {
        event.preventDefault(); event.stopImmediatePropagation(); if (!submitting) error();
      }
    }, true);
    document.addEventListener('globo.formbuilder.form.loaded', function(event) {
      if (!root.contains(event.detail?.form)) return;
      initialize(); reflectCountry();
    });
    document.addEventListener('globo.formbuilder.form.submitting', function(event) {
      if (!root.contains(event.detail?.form)) return;
      submitting = true; if (selector) selector.disabled = true;
    });
    document.addEventListener('globo.formbuilder.form.submitted', function(event) {
      if (!root.contains(event.detail?.form)) return;
      succeeded = true;
      // Let PFB perform the one configured redirect. Do not add another submit, email or conversion event.
    });
    const observer = new MutationObserver(function () {
      initialize();
      // PFB clears its loading class on validation/network failure; allow a deliberate retry.
      if (submitting && !succeeded && !root.querySelector('.action.loading,button.loading')) {
        submitting = false; if (selector) selector.disabled = false;
      }
    });
    observer.observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled']});
    initialize();
    setTimeout(function () { if (!selector && loading) { loading.textContent = labels.error; loading.setAttribute('role','alert'); } }, 15000);
  });
})();
